import { render } from "./reviewsView.vue?vue&type=template&id=700c8ec4"
import script from "./reviewsView.vue?vue&type=script&lang=js"
export * from "./reviewsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__